import styled from "react-emotion";

const ModelContainer = styled("div")`
  color: #1c2541;
  width: 100%;
  margin: 10px;
`;

export default ModelContainer;


// WEBPACK FOOTER //
// ./src/components/model/ModelContainer/index.tsx